import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'

import { useFooter } from './store/modules/footer'
import { useCommon } from './store/modules/common'
import versionTood from '@/utils/versionUpdate'

const storeCommon = useCommon()

storeCommon.setDomain()

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

// 获取cookie
function getCookie(cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return null
}

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  versionTood.isNewVersion()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  useFooter().setBtnList([])
  useFooter().setBtnStr('')
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: router[0] ? router[0].path : '/', query: { redirect: to.fullPath } })
    } else {
      if (permissionStore.getIsAddRouters) {
        if (process.env.NODE_ENV == 'development') {
          //开发环境
          next()
        } else if (process.env.NODE_ENV == 'production') {
          //生产环境
          if (getCookie('account')) {
            next()
          } else {
            localStorage.clear()
            document.cookie = `account=;domain=${storeCommon.getDomainName};expires=Thu, 01 Jan 1970 00:00:00 GMT`
            document.cookie = `token=;domain=${storeCommon.getDomainName};expires=Thu, 01 Jan 1970 00:00:00 GMT`
            next()
          }
        }
        return
      }

      // 开发者可根据实际情况进行修改
      const roleRouters = userStore.getRoleRouters || []

      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      // to.fullPath == '/404' &&
      //   from.fullPath.indexOf('Offer/InternationalResp/OfferHall_IR') !== -1
      // if (to.name === 'NoFind') {
      //   // debugger
      //   // next('/403') // 跳转到403页面无权限页面
      //   console.log('to.fullPath', from)
      //   debugger
      //   next(nextData)
      // } else {
      //   next(nextData)
      // }
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      document.cookie = `account=;domain=${storeCommon.getDomainName};expires=Thu, 01 Jan 1970 00:00:00 GMT`
      document.cookie = `token=;domain=${storeCommon.getDomainName};expires=Thu, 01 Jan 1970 00:00:00 GMT`
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
